export default __webpack_public_path__ + "static/media/sm.ec27dc40.jpg";